import Login from '@/pages/login/login'
import Home from '@/pages/home/home'
import UpdateLog from '@/pages/updateLog/updateLog'
import channelDataTrend from '@/pages/channelDataTrend/channelDataTrend'
import channelExpenseStatistics from '@/pages/channelExpenseStatistics/channelExpenseStatistics'
import channelManagement from '@/pages/channelManagement/channelManagement'
import saveChannel from '@/pages/channelManagement/children/saveChannel'
import clueDataTrend from '@/pages/clueDataTrend/clueDataTrend'
import clueManagement from '@/pages/clueManagement/clueManagement'
import clueTabIndex from '@/pages/clueManagement/clueTabIndex'
import clueDataMonitor from '@/pages/clueDataMonitor/clueDataMonitor'
import expenseSettlement from '@/pages/expenseSettlement/expenseSettlement'
import BusinessList from '@/pages/businessManagement/BusinessList'
import withdrawRecordList from '@/pages/businessManagement/withdrawRecordList'
import insuranceOrder from '@/pages/insuranceManage/insuranceOrder'
import insuranceUser from '@/pages/insuranceManage/insuranceUser'
import insuranceWithdraw from '@/pages/insuranceManage/insuranceWithdraw'
import saveInsuranceOrder from '@/pages/insuranceManage/children/saveInsuranceOrder'
import Setting from '@/pages/setting/Setting'
import thematicManagement from '@/pages/thematicManagement/thematicManagement'
import thematicGroupManagement from '@/pages/thematicGroupManagement/thematicGroupManagement'
import activityManagement from '@/pages/businessManagement/children/activityManagement'
import questionUserManagement from '@/pages/questionUserManagement/questionUserManagement'
import questionManagement from '@/pages/questionManagement/questionManagement'
import addActive from '@/pages/businessManagement/children/addActive'
import productManagement from '@/pages/businessManagement/children/productManagement'
import addProduct from '@/pages/businessManagement/children/addProduct'
import questionDetail from '@/pages/questionManagement/children/questionDetail'
import questionUserDetail from '@/pages/questionUserManagement/children/questionUserDetail'
import wechartSuccess from '@/pages/wechartAuth/wechartSuccess'
import officialPostManagement from '@/pages/officialPost/officialPostManagement'
import OfficialPost from '@/pages/officialPost/children/OfficialPost'
import pincheConfig from '@/pages/channelManagement/children/pincheConfig'
import weChartPayConfig from '@/pages/channelManagement/children//weChartPayConfig'
import addBusiness from '@/pages/businessManagement/children/addBusiness'
import OneBuyCarManager from '@/pages/oneBuyCar/OneBuyCarManager'
import saveThematicDialog from '@/pages/thematicManagement/children/saveThematicDialog'
import saveGroupThematicDialog from '@/pages/thematicGroupManagement/children/saveThematicDialog'
import buriedPointIndex from '@/pages/buriedPoint/buriedPointIndex'
import videoIndex from '@/pages/userVideo/videoIndex'
import userCoinDetail from '@/pages/questionUserManagement/children/userCoinDetail'
import userInviteDetail from '@/pages/questionUserManagement/children/userInviteDetail'
import saveCarExhibition from '@/pages/carExhibition/children/saveCarExhibition'
import carExhibitionManager from '@/pages/carExhibition/carExhibitionManager'
import saveCarExhibitionBusiness from '@/pages/carExhibition/children/saveCarExhibitionBusiness'
import carExhibitionProductManager from '@/pages/carExhibition/children/carExhibitionProductManager'
import carExhibitionActivityManager from '@/pages/carExhibition/children/carExhibitionActivityManager'
import CarExhibitionVideoDetail from '@/pages/carExhibition/children/carExhibitionVideoDetail'
import saveCarExhibitionProduct from '@/pages/carExhibition/children/saveCarExhibitionProduct'
import saveCarExhibitionActivity from '@/pages/carExhibition/children/saveCarExhibitionActivity'
import carExhibitionOrderManager from '@/pages/carExhibition/children/carExhibitionOrderManager'
import carExhibitionWithdrawCashManager from '@/pages/carExhibition/children/carExhibitionWithdrawCashManager'
import AdvertisementManager from '@/pages/carExhibition/children/advertisementManager'
import CsChannel from '@/pages/carExhibition/children/channelManager'
import carExhibitionDetail from '@/pages/carExhibition/children/carExhibitionDetail'
import addAdvertisement from '@/pages/plusadvertisement/children/addAdvertisement'
import addPlusActivity from '@/pages/plusadvertisement/children/addPlusActivity'
import plusBusinessTabIndex from '@/pages/plusbusiness/plusBusinessTabIndex'
import plusIntranetBusinessTabIndex from '@/pages/plusbusiness/plusIntranetBusinessTabIndex'
import addPlusBusiness from '@/pages/plusbusiness/children/addPlusBusiness'
import applyShowPlusBusiness from '@/pages/plusbusiness/children/applyShowPlusBusiness'
import addPlushGoods from '@/pages/plusbusiness/children/addPlushGoods'
import addPlusNewCar from '@/pages/plusbusiness/children/addPlusNewCar'
import addPlusSecondHandCar from '@/pages/plusbusiness/children/addPlusSecondHandCar'
import editIntranetSecondHandCar from '@/pages/plusGoods/children/EditIntranetSecondHandCar'
import addIntranetSecondHandCar from '@/pages/plusbusiness/children/addIntranetSecondHandCar'
import plusGoodsTabIndex from '@/pages/plusGoods/plusGoodsTabIndex'
import authPlusGoodsManager from '@/pages/plusGoods/authPlusGoodsManager'
import plusGoodsTabIndex1 from '@/pages/plusGoods/plusGoodsTabIndex1'
import plusIntranetGoodsTabIndex from '@/pages/plusGoods/plusIntranetGoodsTabIndex'
import TabIndex from '@/pages/plusadvertisement/TabIndex'
import plusOrder from '@/pages/plusOrder/plusOrder'
import PrivateTabIndex from '@/pages/privateCar/PrivateTabIndex'
import withdrawIndex from '@/pages/withdrawCash/withdrawIndex'
import Configure from '@/pages/coinTask/Configure'
import lcwClueManagement from '@/pages/clueManagement/lcwClueManagement'
import Test from '@/pages/Test'
import FinancialTabIndex from '@/pages/financialCenter/FinancialTabIndex'
import FreeTabIndex from '@/pages/free/FreeTabIndex'
import AddReceivables from '@/pages/free/AddReceivables'
import UsedCarLink from '@/pages/privateCar/UsedCarLink'
import SaveUsedCarLink from '@/pages/privateCar/children/SaveUsedCarLink'
import saveUsedCarInfo from '@/pages/privateCar/children/saveUsedCarInfo'
import cardManager from '@/pages/vipCard/cardManager'
import memberManager from '@/pages/vipCard/memberManager'
import fansManager from '@/pages/vipCard/memberManager/fansIndex'
import distributorManager from '@/pages/vipCard/distributorManager'
import consumerCouponsManager from '@/pages/vipCard/consumerCouponsManager'
import transactionRecords from '@/pages/vipCard/transactionRecords'
import withdrawalManager from '@/pages/vipCard/withdrawalManager'
import goodsOrderManager from '@/pages/vipCard/goodsOrderManager'
import SaveConsumerCoupons from '@/pages/vipCard/consumerCouponsManager/children/SaveConsumerCoupons'
import AddDealer from '@/pages/vipCard/distributorManager/children/AddDealer'
import cloudServiceManagerIndex from '@/pages/vipCard/cloudServiceManager'
import otherServiceManagerIndex from '@/pages/vipCard/otherServiceManager'
import DistributorPoster from '@/pages/vipCard/posterManager/DistributorPoster'
import PrivateCarManagement from '@/pages/privateCar/privateCarManagement'
import UsedCarValuation from '@/pages/privateCar/UsedCarValuation'

import vipCardHome from '@/pages/vipCard/home'
import privateCarHome from '@/pages/privateCar/home'

import rechargeOrder from '@/pages/rechargeOrder/rechargeOrder'
import setObdConfig from '@/pages/obdConfig/setObdConfig'
import odbOrder from '@/pages/vipCard/odbOrder'
import memberTabIndex from '@/pages/vipCard/meberData/memberTabIndex'
import GasStationList from '@/pages/gasManagement/GasStationList'
import GasOrderList from '@/pages/gasManagement/GasOrderList'
import GasConfig from '@/pages/gasManagement/GasConfig'
import DbtSettting from '@/pages/plusbusiness/DbtSettting'
import StationAuthInfoDetail from '@/pages/gasManagement/children/StationAuthInfoDetail'
import StationAuthInfoModify from '@/pages/gasManagement/children/StationAuthInfoModify'
import WidthDrawRecord from '@/pages/vipCard/distributorManager/children/WidthDrawRecord'
import navigationManagement from '@/pages/setting/icon/navigationManagement.vue'
import carCircleManagement from '@/pages/setting/icon/carCircleManagement.vue'
import saveCarCircleDialog from '@/pages/setting/icon/saveCarCircleDialog.vue'
import saveNavigationDialog from '@/pages/setting/icon/saveNavigationDialog.vue'
import platIncomeManagement from '@/pages/finance/platIncomeManagement.vue'
import platIncomeAndExpendDetail from '@/pages/finance/platIncomeAndExpendDetail'

import searchcarList from '@/pages/searchcar/searchcarList'
import saveSearchcar from '@/pages/searchcar/children/saveSearchcar'
import clueIntranetManagement from '@/pages/intranetBusiness/clueIntranetManagement'
import clueBusinessIntranetManagement from '@/pages/intranetBusiness/clueBusinessIntranetManagement'
import intranetClueItem from '@/pages/intranetBusiness/children/IntranetClueItem'
import intranetBusinessMemberManagement from '@/pages/intranetBusiness/intranetBusinessMemberManagement'
import intranetBusinessMemberRoleManagement from '@/pages/intranetBusiness/intranetBusinessMemberRoleManagement'
import intranetBusinessMemberRoleItem from '@/pages/intranetBusiness/children/intranetBusinessMemberRoleItem'
import intranetBusinessOrderManagement from '@/pages/intranetBusiness/intranetBusinessOrderManagement'
import businessMemberItem from '@/pages/intranetBusiness/children/businessMemberItem'
import intranetClueCarRecord from '@/pages/intranetBusiness/children/intranetClueCarRecord'
import intranetClueCarRecordManager from '@/pages/intranetBusiness/children/intranetClueCarRecordManager'
import authClueCarRecord from '@/pages/intranetBusiness/children/authClueCarRecord'
import intranetClueCarRecordItem from '@/pages/intranetBusiness/children/intranetClueCarRecordItem'
import actionRecordManagement from '@/pages/intranetBusiness/actionRecordManagement'
import distributionBusinessMaintenanceEmployee from '@/pages/intranetBusiness/children/distributionBusinessMaintenanceEmployee'
import refundBusinessBond from '@/pages/intranetBusiness/children/refundBusinessBond'
import refundBusinessProfit from '@/pages/intranetBusiness/children/refundBusinessProfit'
import accountManage from '@/pages/intranetBusiness/children/accountManage'
import distributionBusinessGroup from '@/pages/wechartCpManagent/children/distributionBusinessGroup'
import distributionClueMaintenanceEmployee from '@/pages/intranetBusiness/children/distributionClueMaintenanceEmployee'
import spreadGoods from '@/pages/plusGoods/children/spreadGoods'
import friendList from '@/pages/friend/friendList'
import friendBindUserList from '@/pages/friendBindUser/friendBindUserList'
import editFriend from '@/pages/friend/editFriend'
import customGroupList from '@/pages/wechartCpManagent/customGroupList'
import joinGroupList from '@/pages/wechartCpManagent/joinGroupList'
import addJoinWay from '@/pages/wechartCpManagent/children/addJoinWay'
import wxNoticeSetting from '@/pages/plusbusiness/children/wxNoticeSetting'
import setBusinessIntranetExtend from '@/pages/plusbusiness/children/setBusinessIntranetExtend'
import intranetProfitRecord from '@/pages/plusbusiness/children/intranetProfitRecord'
import intranetVisitRecord from '@/pages/plusbusiness/children/intranetVisitRecord'
import intranetLegalRecord from '@/pages/plusbusiness/children/intranetLegalRecord'
import contactsLegalList from '@/pages/plusbusiness/children/contactsLegalList'
import clueCity from '@/pages/clueCity/clueCity'
import saveClueFollowRemark from '@/pages/clueManagement/saveClueFollowRemark'
import businessNews from '@/pages/businessNews/businessNews'
import saveBusinessNews from '@/pages/businessNews/children/saveBusinessNews'
import spreadIntranetManagement from '@/pages/intranetBusiness/spreadIntranetManagement'
import devcieIntranetManagement from '@/pages/intranetBusiness/deviceIntranetManagement'
import intranetSpreadRecord from '@/pages/intranetBusiness/children/intranetSpreadRecord'
import intranetDeviceRecord from '@/pages/intranetBusiness/children/intranetDeviceRecord'
import secondMarketManagement from '@/pages/sencondMarket/secondMarketManagement'
import saveOrUpdateSencondMarket from '@/pages/sencondMarket/children/saveOrUpdateSencondMarket'

import intractionActionSeriesContent from '@/pages/intranetBusiness/intractionActionSeriesContent'

import businessKeyWord from '@/pages/businessKeyWord/businessKeyWord'
import saveBusinessKeyWord from '@/pages/businessKeyWord/children/saveBusinessKeyWord'
import protocolVersion from '@/pages/protocolVersion/protocolVersion'
import protocolAuthorization from '@/pages/protocolAuthorization/protocolAuthorization'

let userInfo = localStorage.userInfo
let firstPage = '/login/channel'
if (userInfo) {
  firstPage = '/home'
}

export default [
  { path: '/', redirect: firstPage },
  { path: '/login/:loginType', component: Login },
  { path: '/test/:username', name: 'test', component: Test },
  { path: '/wechartSuccess/:channelId', name: 'wechartSuccess', component: wechartSuccess },
  {
    path: '/home',
    component: Home,
    children: [
      { path: '/', redirect: 'updateLog' },
      { path: 'channelDataTrend', name: '数据趋势', meta: { hasFirstPage: true }, component: channelDataTrend },
      {
        path: 'channelExpenseStatistics',
        name: '费用结算',
        meta: { hasFirstPage: true },
        component: channelExpenseStatistics
      },
      { path: 'channelManagement', name: '渠道管理', meta: { hasFirstPage: true }, component: channelManagement },
      { path: 'clueDataTrend', name: '数据趋势', meta: { hasFirstPage: true }, component: clueDataTrend },
      { path: 'clueDataTrend/:token', name: '数据趋势', component: clueDataTrend },
      { path: 'clueManagement', name: '普通线索', component: clueManagement },
      { path: 'clueTabIndex', name: '线索管理', meta: { hasFirstPage: true }, component: clueTabIndex },
      { path: 'clueDataMonitor', name: '数据监控', meta: { hasFirstPage: true }, component: clueDataMonitor },
      { path: 'businessManagement', name: '商家管理', meta: { hasFirstPage: true }, component: BusinessList },
      { path: 'withdrawRecordList', name: '商家提现', meta: { hasFirstPage: true }, component: withdrawRecordList },
      { path: 'expenseSettlement', name: '费用结算', meta: { hasFirstPage: true }, component: expenseSettlement },
      { path: 'thematicManagement', name: '广告管理', meta: { hasFirstPage: true }, component: thematicManagement },
      { path: 'thematicGroupManagement', name: '群发广告', meta: { hasFirstPage: true }, component: thematicGroupManagement },
      { path: 'questionManagement', name: '帖子管理', meta: { hasFirstPage: true }, component: questionManagement },
      { path: 'questionUserManagement', name: '用户管理', meta: { hasFirstPage: true }, component: questionUserManagement },
      { path: 'updateLog', name: '更新日志', meta: { hasFirstPage: true }, component: UpdateLog },
      { path: 'privateTabIndex', name: '收费统计', meta: { hasFirstPage: true }, component: PrivateTabIndex },
      { path: 'activityManagement/:businessId', name: '商家活动', component: activityManagement },
      { path: 'addActive/:businessId/:businessActiveId', name: '编辑活动', component: addActive },
      { path: 'addActive/:businessId', name: '添加活动', component: addActive },
      { path: 'productManagement/:businessId', name: '商家产品', component: productManagement },
      { path: 'addProduct/:businessId/:businessProductId', name: '修改产品', component: addProduct },
      { path: 'addProduct/:businessId', name: '添加产品', component: addProduct },
      { path: 'questionDetail/:questionId', name: '帖子详情', component: questionDetail },
      { path: 'questionUserDetail/:userId', name: '用户详情', component: questionUserDetail },
      { path: 'freeTabIndex', name: '收款费用', component: FreeTabIndex },
      { path: 'addReceivables', name: '添加收款', component: AddReceivables },
      { path: 'addReceivables/:id', name: '保存收款', component: AddReceivables },
      { path: 'officialPost', name: '官方发帖', meta: { hasFirstPage: true }, component: OfficialPost },
      { path: 'officialPostManagement', name: '官方发帖', meta: { hasFirstPage: true }, component: officialPostManagement },
      { path: 'pincheConfig', name: '拼车配置', meta: { hasFirstPage: true }, component: pincheConfig },
      { path: 'weChartPayConfig', name: '微信商户配置', component: weChartPayConfig },
      { path: 'addBusiness/:id', name: '编辑商家', component: addBusiness },
      { path: 'addBusiness', name: '添加商家', component: addBusiness },
      { path: 'oneBuyCarManager', name: 'oneBuyCarManager', meta: { hasFirstPage: true }, component: OneBuyCarManager },
      { path: 'userCoinDetail/:id', name: '查看明细', component: userCoinDetail },
      { path: 'saveChannel', name: '添加渠道', component: saveChannel },
      { path: 'saveChannel/:id', name: '修改渠道', component: saveChannel },
      { path: 'setting', name: '运营设置', meta: { hasFirstPage: true }, component: Setting },
      { path: 'saveThematicDialog', name: '新增发布', component: saveThematicDialog },
      { path: 'saveThematicDialog/:id', name: '编辑广告', component: saveThematicDialog },
      { path: 'saveGroupThematicDialog', name: '新增群发广告', component: saveGroupThematicDialog },
      { path: 'saveGroupThematicDialog/:id', name: '编辑群发广告', component: saveGroupThematicDialog },
      { path: 'financialCenter', name: '财务中心', meta: { hasFirstPage: true }, component: FinancialTabIndex },
      { path: 'privateCarManagement', name: '二手车管理', meta: { hasFirstPage: true }, component: PrivateCarManagement },
      { path: 'usedCarValuation', name: '二手车估价', meta: { hasFirstPage: true }, component: UsedCarValuation },
      { path: 'saveUsedCarInfo', name: '发布二手车', meta: { hasFirstPage: false }, component: saveUsedCarInfo },
      { path: 'buriedPointIndex', name: '天眼系统', meta: { hasFirstPage: true }, component: buriedPointIndex },
      { path: 'videoIndex', name: '视频', meta: { hasFirstPage: true }, component: videoIndex },
      { path: 'withdrawCash', name: '提现申请', meta: { hasFirstPage: true }, component: withdrawIndex },
      { path: 'configure', name: '任务配置', meta: { hasFirstPage: true }, component: Configure },
      { path: 'lcwClueManagement', name: '推荐线索', component: lcwClueManagement },
      { path: 'userInviteDetail/:id/:withdrawCashId', name: '邀请列表', component: userInviteDetail },
      { path: 'userInviteDetail/:id', name: '邀请列表', component: userInviteDetail },
      { path: 'saveCarExhibition', name: '保存车展信息', component: saveCarExhibition },
      { path: 'saveCarExhibition/:id', name: '修改车展信息', component: saveCarExhibition },
      { path: 'carExhibitionManager', name: '车展管理', meta: { hasFirstPage: true }, component: carExhibitionManager },
      { path: 'addCarExhibitionBusiness/:carShowInfoId', name: '添加车展商家', component: saveCarExhibitionBusiness },
      { path: 'saveCarExhibitionBusiness/:id', name: '保存车展商家', component: saveCarExhibitionBusiness },
      { path: 'carExhibitionProductManager/:businessId', name: '车展商品', component: carExhibitionProductManager },
      { path: 'carExhibitionActivityManager/:businessId', name: '车展活动', component: carExhibitionActivityManager },
      { path: 'addCarExhibitionProduct/:businessId', name: '添加车展商品', component: saveCarExhibitionProduct },
      { path: 'saveCarExhibitionProduct/:id', name: '保存车展商品', component: saveCarExhibitionProduct },
      { path: 'saveCarExhibitionActivity/:id', name: '保存车展活动', component: saveCarExhibitionActivity },
      {
        path: 'carExhibitionActivityManager/addCarExhibitionActivity',
        name: '添加车展活动',
        component: saveCarExhibitionActivity
      },
      { path: 'carExhibitionOrderManager', name: '88订金', component: carExhibitionOrderManager },
      { path: 'carExhibitionWithdrawCashManager', name: '车展币提现', component: carExhibitionWithdrawCashManager },
      { path: 'advertisement', name: '广告位管理', meta: { hasFirstPage: true }, component: AdvertisementManager },
      { path: 'carExhibitionDetail/:carShowInfoId', name: '车展详情', component: carExhibitionDetail },
      { path: 'csChannelManager', name: '渠道管理', meta: { hasFirstPage: true }, component: CsChannel },
      { path: 'addAdvertisement', name: '发布新banner', component: addAdvertisement },
      { path: 'addAdvertisement/:id', name: '修改banner', component: addAdvertisement },
      { path: 'addPlusActivity', name: '发布新活动', component: addPlusActivity },
      { path: 'addPlushActivity/:id', name: '修改活动', component: addPlusActivity },
      { path: 'tabIndex', name: '活动管理', meta: { hasFirstPage: true }, component: TabIndex },
      { path: 'plusBusinessTabIndex', name: '商家管理', meta: { hasFirstPage: true }, component: plusBusinessTabIndex },
      {
        path: 'plusBusinessTabIndex/:activeName',
        name: '商家管理',
        meta: { hasFirstPage: true },
        component: plusBusinessTabIndex
      },
      { path: 'plusIntranetBusinessTabIndex', name: '内网商家', meta: { hasFirstPage: true }, component: plusIntranetBusinessTabIndex },
      { path: 'plusIntranetBusinessTabIndex/wxNoticeSetting', name: '修改微信通知', component: wxNoticeSetting },
      { path: 'plusIntranetBusinessTabIndex/setBusinessIntranetExtend', name: '修改用户等级', component: setBusinessIntranetExtend },
      { path: 'addPlusBusiness', name: '新增plus商家', component: addPlusBusiness },
      { path: 'addCarShowPlusBusiness/:carShowId', name: '新增车展plus商家', component: addPlusBusiness },
      { path: 'addPlusBusiness/:id', name: '修改plus商家', component: addPlusBusiness },
      { path: 'applyShowPlusBusiness/:id', name: '入驻申请审核', component: applyShowPlusBusiness },
      { path: 'addPlushGoods/:businessId/goodstype/:type', name: '添加plus商品', component: addPlushGoods },
      {
        path: 'addPlushGoods/:businessId/goodstype/:type/carShow/:carShowId',
        name: '添加车展plus商品',
        component: addPlushGoods
      },
      { path: 'editPlushGoods/:goodsId', meta: { hasFirstPage: true }, name: '修改plus商品', component: addPlushGoods },
      { path: 'plusGoods', name: 'plus商品', meta: { hasFirstPage: true }, component: plusGoodsTabIndex1 },
      { path: 'plusIntranetGoodsTabIndex', name: '内网车源', meta: { hasFirstPage: true }, component: plusIntranetGoodsTabIndex },
      { path: 'plusOrder', name: 'plus订单', meta: { hasFirstPage: true }, component: plusOrder },
      { path: 'plusGoods/business/:businessId', name: '商家plus商品', component: plusGoodsTabIndex },
      { path: 'plusGoods/business/:businessId/:carShowId', name: '车展商家商品', component: plusGoodsTabIndex },
      { path: 'addPlusNewCar/:businessId', name: '添加plus新车商品', component: addPlusNewCar },
      {
        path: 'addPlusNewCar/:businessId/carShowId/:carShowId',
        name: '添加车展新车商品',
        meta: { hasFirstPage: true },
        component: addPlusNewCar
      },
      {
        path: 'editPlusNewCar/:goodsId/businessId/:businessId',
        name: '修改plus新车商品',
        meta: { hasFirstPage: true },
        component: addPlusNewCar
      },
      { path: 'addPlusSecondHandCar/:businessId', name: '添加plus二手车商品', component: addPlusSecondHandCar },
      {
        path: 'addPlusSecondHandCar/:businessId/carShow/:carShowId',
        name: '添加车展二手车商品',
        component: addPlusSecondHandCar
      },
      {
        path: 'addPlusSecondHandCar/edit/:goodsId/businessId/:businessId',
        name: '修改plus二手车商品',
        component: addPlusSecondHandCar
      },
      {
        path: 'editIntranetSecondHandCar/edit/:goodsId/businessId/:businessId',
        name: '修改内网二手车车源',
        component: editIntranetSecondHandCar
      },

      {
        path: 'addIntranetSecondHandCar/edit/:goodsId/businessId/:businessId',
        name: '查看内网二手车商品',
        component: addIntranetSecondHandCar
      },
      { path: 'usedCarLink', meta: { hasFirstPage: true }, name: '二手车链接', component: UsedCarLink },
      { path: 'saveUsedCarLink', name: '保存二手车渠道', component: SaveUsedCarLink },
      { path: 'saveUsedCarLink/:id', name: '保存二手车渠道', component: SaveUsedCarLink },
      { path: 'cardManager', name: '权益卡管理', meta: { hasFirstPage: true }, component: cardManager },
      { path: 'memberManager', name: '会员列表', meta: { hasFirstPage: true }, component: memberManager },
      { path: 'fansManager', name: '粉丝列表', meta: { hasFirstPage: true }, component: fansManager },
      { path: 'distributorManager', name: '分销人管理', meta: { hasFirstPage: true }, component: distributorManager },
      {
        path: 'consumerCouponsManager',
        name: '消费劵管理',
        meta: { hasFirstPage: true },
        component: consumerCouponsManager
      },
      {
        path: 'consumerCouponsManager/:activeName',
        name: '消费劵管理',
        meta: { hasFirstPage: true },
        component: consumerCouponsManager
      },
      { path: 'transactionRecords', name: '交易记录', meta: { hasFirstPage: true }, component: transactionRecords },
      { path: 'withdrawalManager', name: '提现审核', meta: { hasFirstPage: true }, component: withdrawalManager },
      { path: 'goodsOrderManager', name: '商品订单', meta: { hasFirstPage: true }, component: goodsOrderManager },
      { path: 'saveConsumerCoupons', name: '新增优惠券', component: SaveConsumerCoupons },
      { path: 'saveConsumerCoupons/:id', name: '修改优惠券', component: SaveConsumerCoupons },
      { path: 'addDealer', name: '新增合伙人', component: AddDealer },
      {
        path: 'cloudServiceManagerIndex',
        name: '云服务管理',
        meta: { hasFirstPage: true },
        component: cloudServiceManagerIndex
      },
      {
        path: 'otherServiceManagerIndex',
        name: '第三方服务管理',
        meta: { hasFirstPage: true },
        component: otherServiceManagerIndex
      },
      { path: 'distributorPoster', name: '推广海报管理', meta: { hasFirstPage: true }, component: DistributorPoster },
      {
        path: 'otherServiceManagerIndex',
        name: '第三方服务管理',
        meta: { hasFirstPage: true },
        component: otherServiceManagerIndex
      },
      { path: 'vipCardHome', name: '工作台', meta: { hasFirstPage: true }, component: vipCardHome },
      { path: 'privateCarHome', name: '渠道渠道控制台', meta: { hasFirstPage: true }, component: privateCarHome },
      { path: 'rechargeOrder', name: '云豆充值订单', meta: { hasFirstPage: true }, component: rechargeOrder },
      { path: 'insuranceUser', name: '智保用户', meta: { hasFirstPage: true }, component: insuranceUser },
      { path: 'insuranceWithdraw', name: '绿豆提现', meta: { hasFirstPage: true }, component: insuranceWithdraw },
      { path: 'insuranceOrder', name: '智保订单', meta: { hasFirstPage: true }, component: insuranceOrder },
      { path: 'saveInsuranceOrder', name: '智保订单表单', component: saveInsuranceOrder },
      { path: 'saveInsuranceOrder/:id', name: '智保订单表单', component: saveInsuranceOrder },
      { path: 'searchcarList', name: '求购列表', meta: { hasFirstPage: true }, component: searchcarList },
      { path: 'saveSearchcar', name: '求购发布', component: saveSearchcar },
      { path: 'saveSearchcar/:id', name: '求购发布', component: saveSearchcar },
      { path: 'setObdConfig', name: '智联配置', meta: { hasFirstPage: true }, component: setObdConfig },
      { path: 'odbOrder', name: '智联订单', meta: { hasFirstPage: true }, component: odbOrder },
      { path: 'memberTabIndex', name: '排行榜', meta: { hasFirstPage: true }, component: memberTabIndex },
      { path: 'gasStationList', name: '油站管理', meta: { hasFirstPage: true }, component: GasStationList },
      { path: 'gasOrderList', name: '加油订单', meta: { hasFirstPage: true }, component: GasOrderList },
      { path: 'GasConfig', name: '加油佣金设置', meta: { hasFirstPage: true }, component: GasConfig },
      { path: 'stationAuthInfoDetail', name: '油站资料', component: StationAuthInfoDetail },
      { path: 'stationAuthInfoModify', name: '修改油站资料', component: StationAuthInfoModify },
      { path: 'carExhibitionVideoDetail', name: '编辑视频', component: CarExhibitionVideoDetail },
      { path: 'widthDrawRecord', name: '服务商提现账户管理', meta: { hasFirstPage: true }, component: WidthDrawRecord },
      { path: 'dbtSettting', name: '商家参数设置', meta: { hasFirstPage: true }, component: DbtSettting },
      { path: 'saveCarCircleDialog', name: '编辑车友圈', meta: { hasFirstPage: true }, component: saveCarCircleDialog },
      { path: 'saveNavigationDialog', name: '编辑首页icon导航', meta: { hasFirstPage: true }, component: saveNavigationDialog },
      { path: 'carCircleManagement', name: '车友圈icon管理', meta: { hasFirstPage: true }, component: carCircleManagement },
      { path: 'navigationManagement', name: '首页icon管理', meta: { hasFirstPage: true }, component: navigationManagement },
      { path: 'authPlusGoodsManager', name: '审核商品', meta: { hasFirstPage: true }, component: authPlusGoodsManager },
      { path: 'platIncomeManagement', name: '平台收入', meta: { hasFirstPage: true }, component: platIncomeManagement },
      { path: 'platIncomeAndExpendDetail', name: '收支明细', meta: { hasFirstPage: true }, component: platIncomeAndExpendDetail },
      { path: 'intranetBusinessMemberManagement', name: '付费会员', meta: { hasFirstPage: true }, component: intranetBusinessMemberManagement },
      { path: 'intranetBusinessOrderManagement', name: '付费记录', meta: { hasFirstPage: true }, component: intranetBusinessOrderManagement },
      { path: 'clueIntranetManagement', name: '内网线索', meta: { hasFirstPage: true }, component: clueIntranetManagement },
      { path: 'spreadIntranetManagement', name: '推广通订单', meta: { hasFirstPage: true }, component: spreadIntranetManagement },
      { path: 'intranetSpreadRecord', name: '推广通效果', component: intranetSpreadRecord },
      { path: 'clueBusinessIntranetManagement', name: '内网线索商家', meta: { hasFirstPage: true }, component: clueBusinessIntranetManagement },
      { path: 'intranetClueItem', name: '编辑线索', component: intranetClueItem },
      { path: 'intranetClueCarRecord', name: '收车记录', component: intranetClueCarRecord },
      { path: 'intranetClueCarRecordManager', name: '收车记录维护', component: intranetClueCarRecordManager },
      { path: 'authClueCarRecord', name: '审核申诉', component: authClueCarRecord },
      { path: 'intranetProfitRecord', name: '收益记录', component: intranetProfitRecord },
      { path: 'intranetVisitRecord', name: '跟进记录', component: intranetVisitRecord },
      { path: 'intranetLegalRecord', name: '内网权益记录', component: intranetLegalRecord },
      { path: 'contactsLegalList', name: '人脉明细', component: contactsLegalList },
      { path: 'intranetClueCarRecordItem', name: '编辑记录', component: intranetClueCarRecordItem },
      { path: 'actionRecordManagement', name: '行为商机', meta: { hasFirstPage: true }, component: actionRecordManagement },
      { path: 'businessMemberItem', name: '开通会员', component: businessMemberItem },
      { path: 'distributionBusinessMaintenanceEmployee', name: '编辑商家维护人', component: distributionBusinessMaintenanceEmployee },
      { path: 'refundBusinessBond', name: '退保证金', component: refundBusinessBond },
      { path: 'refundBusinessProfit', name: '扣减收益', component: refundBusinessProfit },
      { path: 'accountManage', name: '账户管理', component: accountManage },
      { path: 'distributionBusinessGroup', name: '编辑商家群', component: distributionBusinessGroup },
      { path: 'distributionClueMaintenanceEmployee', name: '编辑线索维护人', component: distributionClueMaintenanceEmployee },
      { path: 'spreadGoods', name: '推广通', component: spreadGoods },
      { path: 'friendList', name: '朋友圈列表', meta: { hasFirstPage: true }, component: friendList },
      { path: 'friendBindUserList', name: '朋友圈同步用户', meta: { hasFirstPage: true }, component: friendBindUserList },
      { path: 'editFriend', name: '编辑朋友圈', meta: { hasFirstPage: false }, component: editFriend },
      { path: 'intranetBusinessMemberRoleManagement', name: '会员权限', meta: { hasFirstPage: true }, component: intranetBusinessMemberRoleManagement },
      { path: 'intranetBusinessMemberRoleItem', name: '权限修改', component: intranetBusinessMemberRoleItem },
      { path: 'customGroupList', name: '客户群列表', meta: { hasFirstPage: true }, component: customGroupList },
      { path: 'joinGroupList', name: '加群列表', meta: { hasFirstPage: true }, component: joinGroupList },
      { path: 'clueCityList', name: '线索城市列表', meta: { hasFirstPage: true }, component: clueCity },
      { path: 'addJoinWay', name: '编辑入群方式', component: addJoinWay },
      { path: 'saveClueFollowRemark', name: '填写跟进', component: saveClueFollowRemark },
      { path: 'businessNews', name: '内网商家广告管理', meta: { hasFirstPage: true }, component: businessNews },
      { path: 'saveBusinessNews', name: '新增内网发布', component: saveBusinessNews },
      { path: 'saveBusinessNews/:id', name: '编辑内网广告', component: saveBusinessNews },
      { path: 'businessKeyWord', name: '关键词管理', meta: { hasFirstPage: true }, component: businessKeyWord },
      { path: 'saveBusinessKeyWord', name: '新增关键词发布', component: saveBusinessKeyWord },
      { path: 'saveBusinessKeyWord/:id', name: '编辑关键词', component: saveBusinessKeyWord },
      { path: 'protocolVersion', name: '协议版本管理', meta: { hasFirstPage: true }, component: protocolVersion },
      { path: 'protocolAuthorization', name: '协议授权记录', meta: { hasFirstPage: true }, component: protocolAuthorization },

      { path: 'deviceIntranetManagement', name: '群发设备管理', meta: { hasFirstPage: true }, component: devcieIntranetManagement },
      { path: 'intranetDeviceRecord', name: '设备详情', component: intranetDeviceRecord },
      { path: 'secondMarketManagement', name: '车型行情管理', meta: { hasFirstPage: true }, component: secondMarketManagement },
      { path: 'saveOrUpdateSencondMarket', name: '编辑车型行情', component: saveOrUpdateSencondMarket },
      { path: 'intractionActionSeriesContent', name: '查行情记录', meta: { hasFirstPage: true }, component: intractionActionSeriesContent },
    ]
  }]
